import "@features/init";
import startApplication from "@taager/react";
import "./config";
import "./main.css";

// It must be at the end of the file after initial configurations
import "@features/init";

startApplication();
